import React from 'react';
import Div from '../Div';
import FullScreenHorizontalSlider from '../Slider/FullScreenHorizontalSlider';
import VerticalLinks from '../VerticalLinks';

export default function Hero6({
  socialLinksHeading,
  heroSocialLinks,
  showcaseData,
}) {
  return (
    <Div className="cs-hero_6_wrap" style={{
      position: 'relative', // Use relative positioning
      height: '100vh', // Set height to viewport height
      overflow: 'visible' // Allow content to be visible beyond this element
    }}>
      <VerticalLinks data={heroSocialLinks} title={socialLinksHeading} />
      <FullScreenHorizontalSlider data={showcaseData} />
      <Div style={{
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        color: '#fff',
        textAlign: 'center',
        padding: '10px',
        backgroundColor: 'rgba(0,0,0,0.5)',
        borderRadius: '20px'
      }}>
        {/* <p>Scroll Down To See More Content</p>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 auto' }}>
          <path d="M12 4L12 20M12 20L18 14M12 20L6 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg> */}
      </Div>
    </Div>
  );
}